interface IChevronArrowProps {
  activeSidebarTab: number;
  currentActiveTab: number;
}
export const ChevronArrow = ({
  activeSidebarTab,
  currentActiveTab,
}: IChevronArrowProps) => {
  return (
    <svg
      className={`chevron ms-auto dropdown ${
        activeSidebarTab === currentActiveTab ? 'rotate' : ''
      }`}
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.4001 8.20005L10.0001 11.8L13.6001 8.20005"
        stroke="#818898"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default ChevronArrow;
